<div class="v2-warn-strip">
  <i [class]="icon"></i>
  <span><ng-content /></span>
</div>
